import menudoImage from "./images/specials/Menudo.jpeg";
import {menuItems} from "./menuConstants";

export const beveragesCategories = [
  {
    id: 1,
    title: 'Beer',
  },
  {
    id: 2,
    title: 'Seltzer',
  },
  {
    id: 3,
    title: 'Wine',
  },
  {
    id: 4,
    title: 'Margaritas',
  },
  {
    id: 5,
    title: 'Cocktails',
  },
  {
    id: 6,
    title: 'Coca-Cola Products',
  },
  {
    id: 7,
    title: 'Pepsi Products'
  },
  {
    id: 8,
    title: 'Other'
  }
];

export const beveragesItems = [
  {
    id: 1,
    categoryId: 1,
    name: 'Budweiser',
    price: '$3.80',
  },
  {
    id: 2,
    categoryId: 1,
    name: 'Bud Light',
    price: '$3.80',
  },
  {
    id: 3,
    categoryId: 1,
    name: 'Coors Light',
    price: '$3.70',
  },
  {
    id: 4,
    categoryId: 1,
    name: 'Miller Light',
    price: '$3.80',
  },
  {
    id: 5,
    categoryId: 1,
    name: 'Michelob Ultra',
    price: '$3.70',
  },
  {
    id: 6,
    categoryId: 1,
    name: 'Corona',
    price: '$4.0',
  },
  {
    id: 7,
    categoryId: 1,
    name: 'Modelo',
    price: '$4.00',
  },
  {
    id: 8,
    categoryId: 1,
    name: 'Pacifico',
    price: '$4.00',
  },
  {
    id: 9,
    categoryId: 1,
    name: 'Sol',
    price: '$4.00',
  },
  {
    id: 10,
    categoryId: 1,
    name: 'Vctoria',
    price: '$4.00',
  },
  {
    id: 11,
    categoryId: 1,
    name: 'Dos XX',
    price: '$4.00',
  },
  {
    id: 12,
    categoryId: 1,
    name: 'Micheladas',
    price: '$13.00',
  },

  {
    id: 13,
    categoryId: 2,
    name: 'White Claw',
    description: 'Black Cheery, Mango',
    price: '$4.70',
  },
  {
    id: 14,
    categoryId: 2,
    name: 'Corona Seltzer',
    description: 'Cherry, Tropical Lime, Mango, Blackberry Lime',
    price: '$4.70'
  },
  {
    id: 15,
    categoryId: 2,
    name: 'Budlight Seltzer',
    description: 'Lemon Lime, Mango, Strawberry, Black Cherry',
    price: '$4.70'
  },

  {
    id: 16,
    categoryId: 3,
    name: 'La Catrina Moscato',
    price: '$4.25 Glass / $18.00 Bottle'
  },
  {
    id: 17,
    categoryId: 3,
    name: 'La Catrina Sangria',
    price: '$4.25 Glass / $18.00 Bottle'
  },

  {
    id: 18,
    categoryId: 4,
    name: 'Small',
    price: '$4.25'
  },
  {
    id: 19,
    categoryId: 4,
    name: 'Large',
    price: '$6.25'
  },
  {
    id: 20,
    categoryId: 4,
    name: 'Mug',
    price: '$13.75'
  },
  {
    id: 21,
    categoryId: 5,
    name: 'La Catrina Paloma',
  },
  {
    id: 22,
    categoryId: 5,
    name: 'La Catrina Mojito',
  },

  {
    id: 23,
    categoryId: 6,
    name: 'Coca-Cola',
  },
  {
    id: 24,
    categoryId: 6,
    name: 'Diet Coca-Cola',
  },
  {
    id: 25,
    categoryId: 6,
    name: 'Cherry Coke',
  },
  {
    id: 26,
    categoryId: 6,
    name: 'Mexican Bottled Coca-Cola',
    price: '$2.00'
  },
  {
    id: 27,
    categoryId: 6,
    name: 'Sprite',
  },
  {
    id: 28,
    categoryId: 6,
    name: `Barg's Root Beer`,
  },
  {
    id: 29,
    categoryId: 6,
    name: 'Fanta Orange',
  },
  {
    id: 30,
    categoryId: 6,
    name: 'Fanta Grape',
  },
  {
    id: 31,
    categoryId: 6,
    name: 'Lemonade',
  },
  {
    id: 32,
    categoryId: 6,
    name: 'Gold Peak Tea',
    price: '$1.68'
  },
  {
    id: 33,
    categoryId: 6,
    name: 'Dasani Water',
    price: '$1.50'
  },
  {
    id: 34,
    categoryId: 6,
    name: 'Tummy Yummy Kids Drink',
    price: '$1.00'
  },
  {
    id: 35,
    categoryId: 6,
    name: 'Monster Energy',
    price: '$1.98'
  },
  {
    id: 36,
    categoryId: 6,
    name: 'Body Armour',
    price: '$1.79'
  },

  {
    id: 37,
    categoryId: 7,
    name: 'Pepsi'
  },
  {
    id: 38,
    categoryId: 7,
    name: 'Diet Pepsi'
  },
  {
    id: 39,
    categoryId: 7,
    name: 'Wild Cherry Pepsi'
  },
  {
    id: 40,
    categoryId: 7,
    name: 'Sierra Mist'
  },
  {
    id: 41,
    categoryId: 7,
    name: 'Dr. Pepper'
  },
  {
    id: 42,
    categoryId: 7,
    name: 'Mt. Dew'
  },
  {
    id: 43,
    categoryId: 7,
    name: 'Diet Mt. Dew'
  },
  {
    id: 44,
    categoryId: 7,
    name: 'Mt. Dew Major Melon'
  },
  {
    id: 45,
    categoryId: 7,
    name: 'Orange Crush'
  },
  {
    id: 46,
    categoryId: 7,
    name: 'Bang Energy',
    price: '$2.29'
  },
  {
    id: 47,
    categoryId: 7,
    name: 'Pure Leaf Tea',
    price: '$1.88'
  },
  {
    id: 48,
    categoryId: 7,
    name: 'Gatorade',
    price: '$1.50'
  },
  {
    id: 49,
    categoryId: 8,
    name: 'Jarritos',
    price: '$1.50'
  },
  {
    id: 50,
    categoryId: 8,
    name: 'Jumex',
    price: '$1.25'
  },
  {
    id: 51,
    categoryId: 8,
    name: 'Sangria',
    price: '$1.50'
  },
  {
    id: 52,
    categoryId: 8,
    name: 'Coffee',
    price: '$1.25'
  },
  {
    id: 53,
    categoryId: 8,
    name: 'Agua Frescas',
  },
];

export const getBeveragesByCategory = (categoryId) => beveragesItems.filter((item) => item.categoryId === categoryId);
